import Fever from './fever/Fever.svg';
import DrinkWater from './fever/WhatHelps/drinkwater.svg';
import LightClothes from './fever/WhatHelps/lightclothes.svg';
import Rest from './fever/WhatHelps/rest.svg';
import WetCloth from './fever/WhatHelps/wetcloth.svg';
import CantBreath from './fever/WhenToSay/nobreath.svg';
import Shaking from './fever/WhenToSay/Shaking.svg';
import Sleepy from './fever/WhenToSay/Sleepy.svg';
import Rash from './fever/WhenToSay/rash.svg';
import CantDrink from './fever/WhenToSay/nodrink.png';
import Warm from './fever/WhenToSay/warm.svg';
import Hot from './fever/WhenToSay/hot.svg';
import Cold from './fever/WhenToSay/cold.svg';
import Puke from './fever/WhenToSay/puke.svg';
import Lie from './fever/WhenToSay/flat.svg';
import NoCloth from './fever/WhenToSay/noclothes.svg';
import LightCloth from './fever/WhenToSay/lightclothes.svg';
// Vomiting
import Vomiting from './vomiting/VOMITING.svg';
import SipWater from './vomiting/WhatHelps/sipwater.svg';
import Milk from './vomiting/WhatHelps/milk.svg';
import VomitingSleepy from './vomiting/WhatHelps/Sleepy.svg';
import Sit from './vomiting/WhatHelps/sit.svg';
import NoDrink from './vomiting/WhenToSay/nodrink.svg';
import NoPee from './vomiting/WhenToSay/nopee.svg';
import SunkenEyes from './vomiting/WhenToSay/sunkeneyes.svg';
import Cooked from './vomiting/WhenToSay/cooked.svg';
import Vomit from './vomiting/WhenToSay/vomit.svg';
import Sing from './vomiting/WhenToSay/sing.svg';
import Tummy from './vomiting/WhenToSay/tummy.svg';
import DrinkingWater from './vomiting/WhenToSay/drinkwater.svg';
import NoDrinking from './vomiting/WhenToSay/Nodrinking.svg';
import SmallSips from './vomiting/WhenToSay/smallsips.svg';
// Cough
import Cough from './cough/cough.svg';
import Drink from './cough/WhatHelps/drink.svg';
import KeepWarm from './cough/WhatHelps/warm.svg';
import SitDown from './cough/WhatHelps/sit.svg';
import BetterSleep from './cough/WhatHelps/rest.svg';
import Shivering from './cough/WhenToSay/shaking.svg';
import HardBreathe from './cough/WhenToSay/hardbreathe.svg';
import CannotDrink from './cough/WhenToSay/nodrink.svg';
import CoughSleepy from './cough/WhenToSay/rest.svg';
import CoughTwo from './cough/WhatHelps/cough.svg';
import Singing from './cough/WhenToSay/sing.svg';
import Runshout from './cough/WhenToSay/runshout.svg';
import LieFlat from './cough/WhenToSay/flat.svg';
// Diarrhoea
import Diarrhoea from './diarrhoea/diarrhoea.svg';
import DrinkFluids from './diarrhoea/WhatHelps/drinkfluids.svg';
import ORS from './diarrhoea/WhatHelps/ORS.svg';
import SleepBetter from './diarrhoea/WhatHelps/sleep.svg';
import WashHands from './diarrhoea/WhatHelps/washhands.svg';
import VerySleepy from './diarrhoea/WhenToSay/sleepy.svg';
import BloodyPoop from './diarrhoea/WhenToSay/blood.svg';
import NoPeeing from './diarrhoea/WhenToSay/NoPee.svg';
import UnableToDrink from './diarrhoea/WhenToSay/nodrink.svg';
import HardPoo from './diarrhoea/WhenToSay/hardpoo.svg';
import WateryPoo from './diarrhoea/WhenToSay/waterypoo.svg';
import DiarrhoeaSing from './diarrhoea/WhenToSay/singing.svg';
import NoFood from './diarrhoea/WhenToSay/NoFood.svg';
import DiarrhoeaRun from './diarrhoea/WhenToSay/Running.svg';
// Rash
import RashTwo from './rash/rash.svg';
import DrinkMilk from './rash/WhatHelps/drinkmilk.svg';
import KeepCool from './rash/WhatHelps/cool.svg';
import WatchRash from './rash/WhatHelps/rash.svg';
import CleanSkin from './rash/WhatHelps/cleanskin.png';
import MuchSleepy from './rash/WhenToSay/sleep.svg';
import RashShaking from './rash/WhenToSay/shakingYellow.png';
import RashNotAway from './rash/WhenToSay/rashNotAwayYellow.svg';
import VeryWeakRash from './rash/WhenToSay/veryWeakYellow.png';
import QuizShaking from './rash/WhenToSay/quizshake.svg';
import Earpain from './rash/WhenToSay/earpain.svg';
import TummyPain from './rash/WhenToSay/tummypain.svg';
import SkinChanges from './rash/WhenToSay/skinchanges.svg';
import PutOil from './rash/WhenToSay/putoil.svg';
// Ear pain
import EarPain from './earpain/Ear.svg';
import DryEar from './earpain/WhatHelps/dryear.svg';
import CleanEar from './earpain/WhatHelps/cleanear.svg';
import RestQuietly from './earpain/WhatHelps/restquietly.svg';
import TakeMedicine from './earpain/WhatHelps/medicine.svg';
import FluidEar from './earpain/WhenToSay/fluid.svg';
import VeryWeak from './earpain/WhenToSay/veryweak.svg';
import SwollenEar from './earpain/WhenToSay/Ear.svg';
import UnableToDrink2 from './earpain/WhenToSay/drink.svg';
import PutWater from './earpain/WhenToSay/putwater.svg';
import PutOil2 from './earpain/WhenToSay/putoil.svg';
import EarpainSing from './earpain/WhenToSay/sing.svg';
import EarPainFlat from './earpain/WhenToSay/flat.svg';
import IgnoreIt from './earpain/WhenToSay/ignore.svg';
import TellGrownUp from './earpain/WhenToSay/grownup.svg';

const SIGNSANDSYMPTOMSIMAGES = {
  Fever,
  DrinkWater,
  LightClothes,
  Rest,
  WetCloth,
  CantBreath,
  Shaking,
  Sleepy,
  Rash,
  CantDrink,
  Warm,
  Hot,
  Cold,
  Puke,
  Lie,
  NoCloth,
  LightCloth,
  Vomiting,
  SipWater,
  Milk,
  VomitingSleepy,
  Sit,
  NoDrink,
  NoPee,
  SunkenEyes,
  Cooked,
  Vomit,
  Sing,
  Tummy,
  DrinkingWater,
  NoDrinking,
  SmallSips,
  Cough,
  Drink,
  KeepWarm,
  SitDown,
  BetterSleep,
  Shivering,
  HardBreathe,
  CannotDrink,
  CoughSleepy,
  CoughTwo,
  Singing,
  Runshout,
  LieFlat,
  Diarrhoea,
  DrinkFluids,
  ORS,
  SleepBetter,
  WashHands,
  VerySleepy,
  BloodyPoop,
  NoPeeing,
  UnableToDrink,
  HardPoo,
  WateryPoo,
  DiarrhoeaSing,
  NoFood,
  DiarrhoeaRun,
  RashTwo,
  DrinkMilk,
  KeepCool,
  WatchRash,
  CleanSkin,
  MuchSleepy,
  RashShaking,
  RashNotAway,
  VeryWeakRash,
  QuizShaking,
  Earpain,
  TummyPain,
  SkinChanges,
  PutOil,
  EarPain,
  DryEar,
  CleanEar,
  RestQuietly,
  TakeMedicine,
  FluidEar,
  VeryWeak,
  SwollenEar,
  UnableToDrink2,
  PutWater,
  PutOil2,
  EarpainSing,
  EarPainFlat,
  IgnoreIt,
  TellGrownUp,
};

export default SIGNSANDSYMPTOMSIMAGES;
